const state = {
    language: 'fr',
    workLicence: 0.0,
    workMag: 0,
    checkSize: 'sm',
    allSize:{
        saveMenuHeight: 'saveMenuHeightMD',
        pagePadTop: 'pagePadTopMD',
        buttonMenu: 'md',
        buttonItemList: 'sm',
        pagination: 'sm'
    }, 
    //allSize:{
    //    saveMenuHeight: 0,
    //    pagePadTop: 0,
    //    buttonMenu: 'sm',
    //    buttonItemList: 'sm',
    //    pagination: 'sm'
    //}, 
    screenSize: {
        width: 0,
        height: 0,
        vheight: 0, //La hauteur visible sans scrollbar
        menuHeight: 0, //La hauteur du menu des boutons
        navHeight:0, //La hauteur de la navigation
    },
    theme: {
        primary: 'primary',
        secondary: 'secondary',
        success: 'success',
        warning: 'warning',
        danger: 'danger',
        info: 'info',
        light: 'light',
        dark: 'dark',
        oprimary: 'outline-primary',
        osecondary: 'outline-secondary',
        osuccess: 'outline-success',
        owarning: 'outline-warning',
        odanger: 'outline-danger',
        oinfo: 'outline-info',
        olight: 'outline-light',
        odark: 'outline-dark',
    },
    comPort: [
        {id: 1, name: 'COM 1'},
        {id: 2, name: 'COM 2'},
        {id: 3, name: 'COM 3'},
        {id: 4, name: 'COM 4'},
        {id: 5, name: 'COM 5'},
        {id: 6, name: 'COM 6'},
        {id: 7, name: 'COM 7'},
        {id: 8, name: 'COM 8'},
        {id: 9, name: 'COM 9'},
        {id: 10, name: 'COM 10'},
        {id: 11, name: 'COM 11'},
        {id: 12, name: 'COM 12'},
        {id: 13, name: 'COM 13'},
        {id: 14, name: 'COM 14'},
        {id: 15, name: 'COM 15'}
    ],
    comSpeed: [
        {id: 2400, name: '2400'},
        {id: 4800, name: '4800'},
        {id: 7200, name: '7200'},
        {id: 9600, name: '9600'},
        {id: 14400, name: '14400'},
        {id: 19200, name: '19200'},
        {id: 38400, name: '38400'},
        {id: 57600, name: '57600'},
        {id: 115200, name: '115200'}
    ],
    etiPrinter: [
        {id: 1, name: 'Zebra ZD410'}
    ],
    columnHeadersTypes : {
        text        : {name :'text',        alignH: 'text-left   text-nowrap'},
        longtext    : {name :'longtext',    alignH: 'text-left   text-nowrap'},
        numeric     : {name :'numeric',     alignH: 'text-right  text-nowrap'},
        monetary    : {name :'monetary',    alignH: 'text-right  text-nowrap'},
        quantity    : {name :'quantity',    alignH: 'text-right  text-nowrap'},
        boolean     : {name :'boolean',     alignH: 'text-left   text-nowrap'},
        date        : {name :'date',        alignH: 'text-center text-nowrap'},
        time        : {name :'time',        alignH: 'text-center text-nowrap'},
        action      : {name :'action',      alignH: 'text-center text-nowrap'},
    }
}
const getters = {
    getCheckSize: () => {
        return state.checkSize
    },
    getAllSize: () => {
        return state.allSize
    },
    getLanguage: (state) => {
        return state.language
    },
    getTheme: () => {
        return state.theme
    },
    getworkLicence: (state) => {
        return state.workLicence
    },
    getworkMag: () => {
        state.mag = state.workLicence.split(".")
        if(state.mag[1] == '*')
            {return '1'}
        else
            {return state.mag[1]}
    },
    getComPort: () => {
        return state.comPort
    },
    getComSpeed: () => {
        return state.comSpeed
    },
    getEtiPrinter: () => {
        return state.etiPrinter
    },
    getScreenSize: () => {
        return state.screenSize
    },
    getColumnHeader: () => {
        return state.columnHeadersTypes
    }


}
const mutations = {
    changeLanguage: (state, payload) => {
        state.language = payload
    },
    changeAllSize: (state, payload) => {
        state.allSize = payload
    },
    changeworkLicence: (state, payload) => {
        state.workLicence = payload
    },
    changeScreenSizeW: (state, payload) => {
        state.screenSize.width = payload
    },
    changeScreenSizeH: (state, payload) => {
        state.screenSize.height = payload
    },
    changeVisibleScreenSizeH: (state, payload) => {
        state.screenSize.vheight = payload
    },
    changeMenuSaveH: (state, payload) => {
        state.screenSize.menuHeight = payload
    },
    changeNavigationH: (state, payload) => {
        state.screenSize.navHeight = payload
    }
}
const actions = {
}

export default{
    state,
    mutations,
    getters,
    actions
}